function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import debounce from "lodash.debounce";
import { trackEvent } from "services/bigbrain-service";
import { BACKGROUND_IMAGE_CARD_HOVERED } from "constants/bigbrain-event-types";
import DesktopBackgroundImageCard from "./desktop-background-image-card/desktop-background-image-card";
import MobileBackgroundImageCard from "./mobile-background-image-card/mobile-background-image-card";
import { StyledBackgroundImageCardsGridComponent } from "./background-image-cards-grid-component.scss";
import { useMemo } from "react";
import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
const DEBOUNCE_HOVER_TIME = 1000;
const BackgroundImageCardsGridComponent = (_param)=>{
    var { cards, cardHeight, fullParagraphAdvancedConfig, cardsGap } = _param, props = _object_without_properties(_param, [
        "cards",
        "cardHeight",
        "fullParagraphAdvancedConfig",
        "cardsGap"
    ]);
    const onHover = debounce((index)=>{
        trackEvent(BACKGROUND_IMAGE_CARD_HOVERED, {
            info1: index
        });
    }, DEBOUNCE_HOVER_TIME);
    const CardComponent = useMemo(()=>withResponsiveHOC(DesktopBackgroundImageCard, MobileBackgroundImageCard), []);
    return /*#__PURE__*/ _jsx(StyledBackgroundImageCardsGridComponent, {
        cardsGap: cardsGap,
        className: "background-image-cards-grid-component",
        children: cards === null || cards === void 0 ? void 0 : cards.map((card, index)=>/*#__PURE__*/ _createElement(CardComponent, _object_spread(_object_spread_props(_object_spread({}, props), {
                key: index,
                onHover: ()=>onHover(index),
                fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
                cardHeight: cardHeight
            }), card)))
    });
};
export default BackgroundImageCardsGridComponent;
